import { createReducer, on } from '@ngrx/store';
import { initialState } from './bulk-assessment.state';
import * as BulkAssessmentActions from './bulk-assessment.actions';

export const bulkAssessmentReducer = createReducer(
  initialState,
  on(BulkAssessmentActions.setSelectedDomain, (state, { domain }) => ({
    ...state,
    selectedDomain: domain
  })),
  on(BulkAssessmentActions.setBulkAssessmentContext, (state, { classId, standard, assessmentPeriodId, targetedLang }) => ({
    ...state,
    classId,
    standard,
    assessmentPeriodId,
    targetedLang
  })),
  on(BulkAssessmentActions.clearBulkAssessment, () => initialState)
);
